import styled from 'styled-components'
import Headline from '@components/Headline'

export default styled(Headline)`
  text-align: center;
`
